/* © 2026 Ahmad Zubair Sufizada (Zayn Builds). All rights reserved. Licensed for use on JDM Engine Supply Ltd.'s store only. Not to be copied, resold or reused without written permission. */
/*
  JDM extended warranty cart guard (cart page + cart drawer).
  - Warranty qty always equals its unit's qty (matched by the hidden _jdm_for_variant property).
  - Unit removed -> its warranty is removed.
  - Warranty with no matching new/remanufactured unit -> removed + short message.
  - Fixes the drawer quantity selector so going to 0 removes the line.
  - Remove button on the warranty line ([data-jdm-remove]).
*/
(function () {
  var W = Number(window.JDM_WARRANTY_VARIANT || 0)
  if (!W) return

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
  var MSG =
    'The extended warranty can only be added with a new or remanufactured engine or transmission, so we removed it from your cart.'
  var KEY = 'jdmWarrantyMsg'
  var busy = false
  var again = false
  var tagCache = {}

  function isCartPage() {
    return document.body && document.body.classList.contains('template-cart')
  }

  function notify(text) {
    var old = document.getElementById('jdm-wt-toast')
    if (old) old.remove()
    var el = document.createElement('div')
    el.id = 'jdm-wt-toast'
    el.setAttribute('role', 'status')
    el.textContent = text
    el.style.cssText =
      'position:fixed;left:12px;right:12px;top:96px;z-index:2147483000;max-width:520px;margin:0 auto;padding:14px 16px;border-radius:14px;background:#111;color:#fff;font-size:14px;line-height:1.4;box-shadow:0 8px 24px rgba(0,0,0,.25)'
    document.body.appendChild(el)
    setTimeout(function () {
      el.remove()
    }, 7000)
  }

  function eligible(handle) {
    if (!handle) return Promise.resolve(false)
    if (tagCache[handle] !== undefined) return Promise.resolve(tagCache[handle])
    return fetch(root + 'products/' + handle + '.js')
      .then(function (r) {
        return r.ok ? r.json() : null
      })
      .then(function (p) {
        var ok = !!p && (p.tags || []).some(function (t) {
          return t === 'Brand New' || t === 'Remanufactured'
        })
        tagCache[handle] = ok
        return ok
      })
      .catch(function () {
        return true // network error: never remove a warranty by mistake
      })
  }

  function rerender(state) {
    if (isCartPage()) {
      window.location.reload()
      return
    }
    document.dispatchEvent(
      new CustomEvent('ajaxProduct:added', { detail: { product: state, preventCartOpen: true, jdmSync: true } })
    )
  }

  async function sync() {
    if (busy) {
      again = true
      return
    }
    busy = true
    try {
      var cart = await (await fetch(root + 'cart.js', { credentials: 'same-origin' })).json()
      var units = {}
      cart.items.forEach(function (it) {
        if (it.variant_id === W) return
        var k = String(it.variant_id)
        units[k] = units[k] || { qty: 0, handle: it.handle }
        units[k].qty += it.quantity
      })

      var updates = {}
      var orphan = false
      var seen = {}
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i]
        if (it.variant_id !== W) continue
        var forV = it.properties && it.properties._jdm_for_variant ? String(it.properties._jdm_for_variant) : ''
        var unit = forV ? units[forV] : null
        var ok = !!unit && (await eligible(unit.handle))
        var want = 0
        if (ok && !seen[forV]) {
          want = unit.qty
          seen[forV] = true
        }
        if (!forV || (unit && !ok)) orphan = true
        if (want !== it.quantity) updates[it.key] = want
      }

      if (!Object.keys(updates).length) return

      var res = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates, sections: 'cart-ajax' })
      })
      var state = await res.json()
      if (orphan) {
        if (isCartPage()) {
          try {
            sessionStorage.setItem(KEY, '1')
          } catch (e) {}
        } else {
          notify(MSG)
        }
      }
      rerender(state)
    } catch (e) {
      console.warn('JDM warranty sync', e)
    } finally {
      busy = false
      if (again) {
        again = false
        sync()
      }
    }
  }

  async function removeLine(key) {
    try {
      var res = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0, sections: 'cart-ajax' })
      })
      var state = await res.json()
      if (isCartPage()) {
        await sync()
        window.location.reload()
        return
      }
      rerender(state)
      sync()
    } catch (e) {
      console.warn('JDM remove line', e)
    }
  }

  // Drawer/page quantity selector set to 0 -> remove the line (theme ignores 0).
  document.addEventListener(
    'cart:quantity',
    function (evt) {
      var d = evt.detail || []
      if (d[0] && Number(d[1]) === 0) {
        evt.stopImmediatePropagation()
        removeLine(d[0])
      }
    },
    true
  )

  // Remove button on the warranty line.
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('[data-jdm-remove]')
    if (!btn) return
    evt.preventDefault()
    btn.setAttribute('aria-busy', 'true')
    removeLine(btn.getAttribute('data-jdm-remove'))
  })

  document.addEventListener('cart:updated', function () {
    sync()
  })
  document.addEventListener('ajaxProduct:added', function (evt) {
    if (evt.detail && evt.detail.jdmSync) return
    sync()
  })
  document.addEventListener('cart:open', function () {
    sync()
  })
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-jdm-warranty-toggle] input').forEach(function (i) {
      i.checked = false
    })
  })

  function start() {
    try {
      if (sessionStorage.getItem(KEY)) {
        sessionStorage.removeItem(KEY)
        notify(MSG)
      }
    } catch (e) {}
    sync()
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start)
  else start()
})()
